export default __webpack_public_path__ + "static/media/pic-message-answer.5f2f1896.png";